import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "../Exceptions.index.css";

interface ExceptionToolbarProps {
  onSearch: (value: string) => void;
}

const ExceptionToolbar = ({ onSearch }: ExceptionToolbarProps) => {
  return (
    <div className="exceptions-toolbar">
      <div className="exceptions-heading">Exception Logs</div>
      <Input
        placeholder="Search exceptions..."
        prefix={<SearchOutlined />}
        onChange={(e) => onSearch(e.target.value)}
        allowClear
        style={{ width: 300, marginRight: "20px" }}
      />
    </div>
  );
};

export default ExceptionToolbar;
